// extracted by mini-css-extract-plugin
export default {"colors":"\"~styles/colors.module.css\"","slightly-less-dark-gray":"#333333","slightlyLessDarkGray":"#333333","container":"GraphSkeleton_container__l5SQF"};